import { PageTemplate } from 'components/PageTemplate';
import { ApplicationBoard } from 'components/ApplicationBoard';

export const Archive = () => (
  <PageTemplate title="Архив заявок">
    <ApplicationBoard status="finished" commonUrl="/application/underway" />
  </PageTemplate>
);
